import { useState } from "react";
import { FaBars } from "react-icons/fa";
import CustomModal from "./CustomModal";
import { useNavigate } from "react-router-dom";
import { getAccessibleMenus, getDefaultAccessiblePath } from "../../utils/menuAccess";

const Navbar = ({ onToggleSidebar }) => {
  const navigation = useNavigate();
  const [modelOpen, setModelOpen] = useState(false);
  const [query, setQuery] = useState("");
  const menus = getAccessibleMenus();

  const menuItems = menus.flatMap((menu) =>
    menu.items.map((item) => ({
      ...item,
      menuName: menu.name,
      searchText: `${menu.name} ${item.name}`.toLowerCase(),
    }))
  );

  const results = query.trim()
    ? menuItems.filter((item) => item.searchText.includes(query.toLowerCase())).slice(0, 8)
    : [];

  const goToMenu = (path) => {
    navigation(path);
    setQuery("");
  };

  const logOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.reload();
  };

  return (
    <>
      <CustomModal
        show={modelOpen}
        title="Confirm Logout"
        message="Are you sure you want to logout?"
        onConfirm={() => {
          logOut();
          setModelOpen(false);
        }}
        onCancel={() => setModelOpen(false)}
      />

      <nav
        className="navbar navbar-light px-3 fixed-top"
        style={{
          backgroundColor: "#f8f9fa",
          height: "6vw",
          width: "100%",     
          boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
          zIndex: 1050,     
        }}
      >
        {/* Hamburger for mobile */}
        <button
          className="btn d-md-none me-2"
          onClick={onToggleSidebar}
          style={{ boxShadow: "none" }}
        >
          <FaBars size={20} />
        </button>
          <img
            src="/assets/logo.jpeg"
            alt="Description"
            onClick={() => navigation(getDefaultAccessiblePath())}
            className="d-none d-md-block"
            style={{ width: "5vw", height: "5vw", borderRadius: "50%", cursor: "pointer", marginLeft: "2vw" }}
          />
        <div className="d-flex align-items-center justify-content-end gap-2 flex-grow-1">
          <div className="position-relative" style={{ maxWidth: "70vw", width: "100%" }}>
            <input
              className="form-control form-control-sm"
              placeholder="Search menu..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && results[0]) goToMenu(results[0].path);
              }}
              style={{ boxShadow: "none" }}
            />
            {results.length > 0 && (
              <div
                className="position-absolute bg-white border rounded shadow-sm w-100 mt-1"
                style={{ zIndex: 2000, maxHeight: 280, overflowY: "auto" }}
              >
                {results.map((item) => (
                  <button
                    key={item.path}
                    className="btn btn-link text-start text-decoration-none w-100 px-3 py-2"
                    onClick={() => goToMenu(item.path)}
                  >
                    <div className="fw-semibold text-dark">{item.name}</div>
                    <small className="text-muted">{item.menuName}</small>
                  </button>
                ))}
              </div>
            )}
          </div>
          <button className="btn btn-sm btn-primary" style={{ boxShadow: "none" }} onClick={() => results[0] && goToMenu(results[0].path)}>
            Search
          </button>
          <button
            className="btn btn-sm btn-outline-danger d-flex align-items-center gap-1"
            onClick={() => setModelOpen(true)}
            style={{ boxShadow: "none" }}
          >
            <i className="fa-solid fa-right-from-bracket"></i> ⏻
          </button>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
